import React, { useState } from 'react';
import { ChevronRight, Code, Mail, Github, Linkedin, MessageSquare, Menu, X } from 'lucide-react';

const Comingsoon = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className="bg-white shadow-sm relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center">
              <div className="flex items-center">
                <Code className="h-10 w-10 text-indigo-600" />
                <span className="ml-2 text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 text-transparent bg-clip-text">
                  CodeSpirit
                </span>
              </div>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-indigo-600 font-medium">Home</a>
              <a href="/coming-soon" className="text-gray-700 hover:text-indigo-600 font-medium">Hackathons</a>
              <a href="/contact" className="text-gray-700 hover:text-indigo-600 font-medium">Contact Us</a>
              <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">
                Join Now
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-indigo-600 focus:outline-none"
              >
                {isMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                <a
                  href="/"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Home
                </a>
                <a
                  href="/coming-soon"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Hackathons
                </a>
                <a
                  href="/contact"
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50"
                >
                  Contact Us
                </a>
                <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">
                Join Now
              </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Rest of the component remains the same */}
      {/* Hero Section */}
      <main className="flex-grow">
        {/* ... rest of the main content ... */}
        <div className="relative bg-white overflow-hidden">
          <div className="max-w-7xl mx-auto">
            <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
              <div className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
                <div className="sm:text-center lg:text-left">
                  <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                    <span className="block">Welcome to CodeSpirit</span>
                    <span className="block text-indigo-600">Coming Soon!</span>
                  </h1>
                  <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                    Join our thriving community of 2000+ tech enthusiasts. CodeSpirit is your ultimate destination for hackathons, 
                    networking, and collaborative learning in the tech world.
                  </p>
                  <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                    <div className="rounded-md shadow">
                      <a href="#" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10">
                        Connect with Us
                        <ChevronRight className="ml-2 h-5 w-5" />
                      </a>
                    </div>
                    <div className="mt-3 sm:mt-0 sm:ml-3">
                      <a href="#" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-indigo-100 hover:bg-indigo-200 md:py-4 md:text-lg md:px-10">
                        Learn More
                      </a>
                    </div>
                  </div>

                  {/* Coming Soon Features */}
                  <div className="mt-12 bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-bold text-gray-900 mb-4">Coming Soon Features:</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-start space-x-2">
                        <div className="h-2 w-2 bg-indigo-600 rounded-full mt-2"></div>
                        <p className="text-gray-600">Live Hackathon Platform</p>
                      </div>
                      <div className="flex items-start space-x-2">
                        <div className="h-2 w-2 bg-indigo-600 rounded-full mt-2"></div>
                        <p className="text-gray-600">Community Forums</p>
                      </div>
                      <div className="flex items-start space-x-2">
                        <div className="h-2 w-2 bg-indigo-600 rounded-full mt-2"></div>
                        <p className="text-gray-600">Resource Library</p>
                      </div>
                      <div className="flex items-start space-x-2">
                        <div className="h-2 w-2 bg-indigo-600 rounded-full mt-2"></div>
                        <p className="text-gray-600">Mentorship Programs</p>
                      </div>
                    </div>
                    <p className="mt-4 text-gray-500 text-sm">
                      Have suggestions or want to learn more? Reach out through our contact section below!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

       {/* Footer */}
       <footer className="bg-gray-900">
              <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                  <div className="col-span-1 md:col-span-2">
                    <div className="flex items-center">
                      <Code className="h-8 w-8 text-white" />
                      <span className="ml-2 text-xl font-bold text-white">CodeSpirit</span>
                    </div>
                    <p className="mt-4 text-gray-400">
                      Building the future of tech communities, one hackathon at a time.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-4">Quick Links</h3>
                    <ul className="space-y-2">
                      <li><a href="/coming-soon" className="text-gray-400 hover:text-white">About Us</a></li>
                      <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Events</a></li>
                      <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Community</a></li>
                      <li><a href="/coming-soon" className="text-gray-400 hover:text-white">Contact</a></li>
                    </ul>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-6">Connect With Us</h3>
                                 <div className="space-y-4">
                                   <a href="https://whatsapp.com/channel/0029VapOKPqHAdNXNTwL2I1M" className="flex items-center text-gray-400 hover:text-white">
                                     <MessageSquare className="h-6 w-6 mr-3" />
                                     <span>Join our WhatsApp Channel</span> 
                                   </a>
                                   <a href="https://www.linkedin.com/company/codespirit" className="flex items-center text-gray-400 hover:text-white">
                                     <Linkedin className="h-6 w-6 mr-3" />
                                     <span>Follow us on LinkedIn</span> 
                                   </a>
                                   <a href="mailto:contact@codespirit.in" className="flex items-center text-gray-400 hover:text-white">
                                     <Mail className="h-6 w-6 mr-3" />
                                     <span>contact@codespirit.in</span> 
                                   </a>
                                   <a href="#" className="flex items-center text-gray-400 hover:text-white">
                                     <Github className="h-6 w-6 mr-3" />
                                     <span>Check our GitHub</span> 
                                   </a>
                                 </div>
                  </div>
                </div>
                <div className="mt-8 border-t border-gray-800 pt-8">
                  <p className="text-gray-400 text-center">
                    © 2025 <a href="/" className="items-center hover:text-white">
                                     <span className='text-blue-600' >CodeSpirit</span> 
                                   </a> All rights reserved.
                  </p>
                </div>
              </div>
            </footer>
    </div>
  );
};

export default Comingsoon;